import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { AppLayoutComponent } from './layout/app.layout.component';

const routes: Routes = [
  { 
    path: 'login', 
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) 
  },
  {
    path: '', 
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { 
        path: '', 
        loadChildren: () => import('./modules/views/products/products.module').then(m => m.ProductsModule) 
      },
      { 
        path: 'cart', 
        loadChildren: () => import('./modules/views/cart/cart.module').then(m => m.CartModule) 
      },
      { 
        path: 'orders', 
        loadChildren: () => import('./modules/views/orders/orders.module').then(m => m.OrdersModule) 
      },
    ]
},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
